import { useEffect, useRef } from 'react';

/**
 * This hook accepts a single boolean and fires the callback when the boolean goes from
 * 'true' to 'false'. This is useful for triggering events when an IO call is finished.
 */
const useOnDone = (cb: () => void, dep: boolean | null | undefined) => {
  const prev = useRef<boolean | null | undefined>(undefined);
  useEffect(() => {
    if (prev.current !== dep) {
      const prevVal = prev.current;
      prev.current = dep;
      if (!!prevVal && !dep) {
        cb();
      }
    }
  }, [dep]);
};

// **** Export **** //

export default useOnDone;
